import { Link } from 'react-router';

import { Button } from '@/components/ui';

function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 overflow-hidden p-6 text-center">
      {/* The photo is on white; multiply lets the page colour show through it in light mode. */}
      <img
        src="food-404.jpg"
        alt="404"
        width={576}
        height={384}
        className="h-auto w-full max-w-xl rounded-auditor-lg mix-blend-multiply dark:mix-blend-normal"
      />
      <div className="flex flex-col items-center gap-4">
        <h1 className="m-0 text-4xl font-semibold tracking-title text-ink">Page Not Found</h1>
        <p className="m-0 max-w-md text-sm text-ink-muted">
          The page you are looking was moved, removed, renamed, or might never have existed!
        </p>
        <Button asChild>
          <Link to="/">Back To Home</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
